"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.knowledge.base': 'Baza Wiedzy',
    'onboarding.knowledge.title': 'Baza Wiedzy (Opcjonalne)',
    'onboarding.knowledge.description': 'Dodaj wpisy wiedzy, aby zwiększyć wiedzę i odpowiedzi swojego awatara.',
    'onboarding.knowledge.final.step': 'Ostatni Krok - Przesyłanie Wiedzy',
    'onboarding.knowledge.label': 'Wybierz Wpisy Wiedzy',
    'onboarding.knowledge.placeholder': 'Wyszukaj i wybierz wpisy wiedzy dla swojego awatara...',
    'onboarding.knowledge.skip.info': 'Możesz pominąć ten krok i dodać wpisy wiedzy później, jeśli potrzebujesz.',
    'onboarding.knowledge.selected.single': 'wpis wiedzy wybrany',
    'onboarding.knowledge.selected.multiple': 'wpisy wiedzy wybrane',
    'onboarding.knowledge.bonus': 'Wiedza dodana',
    'onboarding.knowledge.items': 'Elementy Wiedzy',
};
